/**
 * AUTO GENERATED :: DO NOT EDIT DIRECTLY
 */

type Parameter = string | number;
export const Endpoints = {
  login: "/login",
  "login.sso": "/api/login/sso/{type}",
  admin: "/admin",
  dashboard: "/",
  account: "/account",
  tasks: "/tasks",
  colony: "/colony",
  "colony.add.cage": "/colony/add/study/{studyId}",
  "colony.add": "/colony/add",
  "colony.add.study": "/colony/add?study&#x3D;{studyId}",
  "colony.manage_cages": "/colony/cages/manage",
  "colony.edit.cages": "/colony/edit/cages",
  "colony.edit.animals": "/colony/edit/animals",
  "colony.add.animals": "/colony/{id}/add-animals",
  "colony.animal.profile": "/colony/profile/{subjectId}",
  "tasks.templates": "/tasks/templates",
  "tasks.templates.new": "/tasks/templates/new",
  samples: "/samples",
  approvals: "/approvals",
  "approvals.details": "/approvals/{approvalRequestId}",
  requests: "/requests",
  agents: "/ai-agents",
  "agents.setup": "/agents/{slug}/setup",
  "agents.session": "/agents/{slug}/{sessionApiId}",
  "requests.details": "/requests/{requestId}",
  "randomization.report": "/studies/{id}/randomization/{reportApiId}",
  "password.forget": "/forgot-password",
  "password.reset": "/reset-password",
  "teams.none": "/teams/none",
  "team.manage": "/team",
  "team.glossary.metadata": "/team/glossary/metadata",
  "team.glossary.observations": "/team/glossary/observations",
  "team.glossary.samples": "/team/glossary/samples",
  "team.glossary.deceased": "/team/glossary/deceased",
  "team.glossary.species_strains": "/team/glossary/species-and-strains",
  "team.glossary.treatments": "/team/glossary/treatments",
  "team.glossary.presets": "/team/glossary/presets",
  "team.glossary.presets.create": "/team/glossary/presets/create",
  "team.glossary.presets.edit": "/team/glossary/presets/{presetApiId}/edit",
  "team.glossary.presets.clone": "/team/glossary/presets/{presetApiId}/clone",
  "team.studies.approvals": "/team/studies/approvals",
  "team.studies.approvals.create": "/team/studies/approvals/create",
  "team.studies.approvals.edit": "/team/studies/approvals/{approvalTemplate}/edit",
  "team.studies.approvals.form": "/team/studies/approvals/form",
  "team.studies.requests": "/team/studies/requests",
  "team.studies.requests.create": "/team/studies/requests/create",
  "team.studies.requests.edit": "/team/studies/requests/{requestTemplate}/edit",
  "team.studies.cage_cards": "/team/studies/cage-cards",
  "team.studies.devices": "/team/studies/devices",
  "team.studies.benchling_sync": "/team/benchling-sync",
  "team.studies.benchling_sync.tab": "/team/benchling-sync?tab&#x3D;{tab}",
  "team.studies.benchling_sync.events": "/team/benchling-sync/{benchlingBackfillApiId}/events",
  "team.studies.groups": "/team/studies/groups",
  "team.studies.study_codes": "/team/studies/study-codes",
  "team.studies.study_codes.create": "/team/studies/study-codes/create",
  "team.studies.study_codes.edit": "/team/studies/study-codes/{studyCodeApiId}/edit",
  "team.studies.forms": "/team/studies/forms",
  "team.studies.forms.create": "/team/studies/forms/create",
  "team.studies.forms.edit": "/team/studies/forms/{id}",
  "team.integrations.sso": "/team/integrations/sso",
  "team.integrations.devices": "/team/integrations/devices",
  "team.integrations.api": "/team/integrations/api",
  "team.integrations.webhooks": "/team/integrations/webhooks",
  "team.integrations.webhooks.events": "/team/integrations/webhooks/{webhookApiId}/events",
  "team.admin.feature_flags": "/team/admin-console/feature-flags",
  "team.admin.integration": "/team/admin-console/integration",
  "team.admin.sync": "/team/admin-console/sync",
  "team.admin.tickatlab": "/team/admin-console/tickatlab",
  "team.admin.sse_presence": "/team/admin-console/sse-presence",
  "team.admin.invivo_study_health_check": "/team/admin-console/invivo-study-health-check",
  "team.admin.invivo_study_protocol_parser": "/team/admin-console/invivo-study-protocol-parser",
  "team.admin.team_config": "/team/admin-console/team-config",
  "studies.new": "/studies/new?formId&#x3D;{formId}",
  "studies.new.draft": "/studies/new?formId&#x3D;{formId}&amp;draftId&#x3D;{draftId}",
  "studies.show": "/studies/{id}",
  "studies.recaging": "/studies/{studyId}/recaging",
  "studies.overview": "/studies/{id}",
  "studies.schedule": "/studies/{id}/schedule",
  "studies.approvals": "/studies/{id}/approvals/{approvalRequestId}",
  "studies.requests": "/studies/{id}/requests?requestTemplate&#x3D;{requestTemplateId}",
  "studies.requests.edit": "/studies/{id}/requests/{requestId}",
  "studies.collections.show": "/studies/{id}/{id}",
  "studies.graphs": "/studies/{id}/graphs/",
  "studies.studyGroups": "/studies/{id}/study-groups",
  "studies.studyGroups.tab": "/studies/{id}/study-groups?tab&#x3D;{tab}",
  "studies.animals": "/studies/{id}/animals/",
  "studies.animals.edit": "/studies/{id}/animals/edit",
  "studies.cages": "/studies/{id}/cages/",
  "studies.workflow": "/studies/{id}/workflow",
  "studies.attachments": "/studies/{id}/attachments/",
  "studies.samples": "/studies/{id}/samples/",
  "studies.samples.edit": "/studies/{id}/samples/edit",
  "studies.samples.execute": "/studies/{id}/samples/execute",
  "studies.samples.execute.collect": "/studies/{id}/samples/execute/collect",
  "studies.settings": "/studies/{id}/settings/",
  "studies.observations": "/studies/{id}/observations/",
  "studies.import": "/studies/{id}/import/",
  "studies.export": "/studies/{id}/export/",
  "studies.export.download": "/studies/{studyApiId}/exports/{exportApiId}/download",
  "exports.download": "/exports/{exportApiId}/download",
  "studies.benchlingSync": "/studies/{id}/benchling-sync",
  "studies.randomization": "/studies/{id}/randomization",
  "studies.dataTables.list": "/studies/{id}/datatables",
  "studies.dataTables.create": "/studies/{id}/datatables/create",
  "studies.templates.dataTables.create": "/studies/{id}/templates/datatables/create",
  "studies.dataTables.show": "/studies/{id}/datatables/{dataTableApiId}",
  "studies.dosing.list": "/studies/{id}/dosing",
  "studies.dosing.create": "/studies/{id}/dosing/create/{classification}",
  "studies.move.animals": "/studies/{studyId}/move-animals",
  "animals.show": "/studies/{id}/animals/{subject_id}",
  "animals.show.tab": "/studies/{id}/animals/{subject_id}?tab&#x3D;{tab}",
  "subjects.show": "/studies/{id}/animals/{subject_id}",
  help: "https://help.benchling.com/hc/en-us/sections/18965531484813-Benchling-In-Vivo",
  community: "https://community.benchling.com/",
  "unsupported.client.version": "/unsupported-client-version",
} as const;

export type EndpointParameters = {
  login: {};
  "login.sso": {
    type?: Parameter;
  };
  admin: {};
  dashboard: {};
  account: {};
  tasks: {};
  colony: {};
  "colony.add.cage": {
    studyId?: Parameter;
  };
  "colony.add": {};
  "colony.add.study": {
    studyId?: Parameter;
  };
  "colony.manage_cages": {};
  "colony.edit.cages": {};
  "colony.edit.animals": {};
  "colony.add.animals": {
    id?: Parameter;
  };
  "colony.animal.profile": {
    subjectId?: Parameter;
  };
  "tasks.templates": {};
  "tasks.templates.new": {};
  samples: {};
  approvals: {};
  "approvals.details": {
    approvalRequestId?: Parameter;
  };
  requests: {};
  agents: {};
  "agents.setup": {
    slug?: Parameter;
  };
  "agents.session": {
    slug?: Parameter;
    sessionApiId?: Parameter;
  };
  "requests.details": {
    requestId?: Parameter;
  };
  "randomization.report": {
    id?: Parameter;
    reportApiId?: Parameter;
  };
  "password.forget": {};
  "password.reset": {};
  "teams.none": {};
  "team.manage": {};
  "team.glossary.metadata": {};
  "team.glossary.observations": {};
  "team.glossary.samples": {};
  "team.glossary.deceased": {};
  "team.glossary.species_strains": {};
  "team.glossary.treatments": {};
  "team.glossary.presets": {};
  "team.glossary.presets.create": {};
  "team.glossary.presets.edit": {
    presetApiId?: Parameter;
  };
  "team.glossary.presets.clone": {
    presetApiId?: Parameter;
  };
  "team.studies.approvals": {};
  "team.studies.approvals.create": {};
  "team.studies.approvals.edit": {
    approvalTemplate?: Parameter;
  };
  "team.studies.approvals.form": {};
  "team.studies.requests": {};
  "team.studies.requests.create": {};
  "team.studies.requests.edit": {
    requestTemplate?: Parameter;
  };
  "team.studies.cage_cards": {};
  "team.studies.devices": {};
  "team.studies.benchling_sync": {};
  "team.studies.benchling_sync.tab": {
    tab?: Parameter;
  };
  "team.studies.benchling_sync.events": {
    benchlingBackfillApiId?: Parameter;
  };
  "team.studies.groups": {};
  "team.studies.study_codes": {};
  "team.studies.study_codes.create": {};
  "team.studies.study_codes.edit": {
    studyCodeApiId?: Parameter;
  };
  "team.studies.forms": {};
  "team.studies.forms.create": {};
  "team.studies.forms.edit": {
    id?: Parameter;
  };
  "team.integrations.sso": {};
  "team.integrations.devices": {};
  "team.integrations.api": {};
  "team.integrations.webhooks": {};
  "team.integrations.webhooks.events": {
    webhookApiId?: Parameter;
  };
  "team.admin.feature_flags": {};
  "team.admin.integration": {};
  "team.admin.sync": {};
  "team.admin.tickatlab": {};
  "team.admin.sse_presence": {};
  "team.admin.invivo_study_health_check": {};
  "team.admin.invivo_study_protocol_parser": {};
  "team.admin.team_config": {};
  "studies.new": {
    formId?: Parameter;
  };
  "studies.new.draft": {
    formId?: Parameter;
    draftId?: Parameter;
  };
  "studies.show": {
    id?: Parameter;
  };
  "studies.recaging": {
    studyId?: Parameter;
  };
  "studies.overview": {
    id?: Parameter;
  };
  "studies.schedule": {
    id?: Parameter;
  };
  "studies.approvals": {
    id?: Parameter;
    approvalRequestId?: Parameter;
  };
  "studies.requests": {
    id?: Parameter;
    requestTemplateId?: Parameter;
  };
  "studies.requests.edit": {
    id?: Parameter;
    requestId?: Parameter;
  };
  "studies.collections.show": {
    id?: Parameter;
  };
  "studies.graphs": {
    id?: Parameter;
  };
  "studies.studyGroups": {
    id?: Parameter;
  };
  "studies.studyGroups.tab": {
    id?: Parameter;
    tab?: Parameter;
  };
  "studies.animals": {
    id?: Parameter;
  };
  "studies.animals.edit": {
    id?: Parameter;
  };
  "studies.cages": {
    id?: Parameter;
  };
  "studies.workflow": {
    id?: Parameter;
  };
  "studies.attachments": {
    id?: Parameter;
  };
  "studies.samples": {
    id?: Parameter;
  };
  "studies.samples.edit": {
    id?: Parameter;
  };
  "studies.samples.execute": {
    id?: Parameter;
  };
  "studies.samples.execute.collect": {
    id?: Parameter;
  };
  "studies.settings": {
    id?: Parameter;
  };
  "studies.observations": {
    id?: Parameter;
  };
  "studies.import": {
    id?: Parameter;
  };
  "studies.export": {
    id?: Parameter;
  };
  "studies.export.download": {
    studyApiId?: Parameter;
    exportApiId?: Parameter;
  };
  "exports.download": {
    exportApiId?: Parameter;
  };
  "studies.benchlingSync": {
    id?: Parameter;
  };
  "studies.randomization": {
    id?: Parameter;
  };
  "studies.dataTables.list": {
    id?: Parameter;
  };
  "studies.dataTables.create": {
    id?: Parameter;
  };
  "studies.templates.dataTables.create": {
    id?: Parameter;
  };
  "studies.dataTables.show": {
    id?: Parameter;
    dataTableApiId?: Parameter;
  };
  "studies.dosing.list": {
    id?: Parameter;
  };
  "studies.dosing.create": {
    id?: Parameter;
    classification?: Parameter;
  };
  "studies.move.animals": {
    studyId?: Parameter;
  };
  "animals.show": {
    id?: Parameter;
    subject_id?: Parameter;
  };
  "animals.show.tab": {
    id?: Parameter;
    subject_id?: Parameter;
    tab?: Parameter;
  };
  "subjects.show": {
    id?: Parameter;
    subject_id?: Parameter;
  };
  help: {};
  community: {};
  "unsupported.client.version": {};
};
